module.exports = __webpack_public_path__ + "static/img/9.70e8584.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/9.png
// module id = G1jt
// module chunks = 35